import { Link } from '@utmb/design-system/link/link';
import { ReactElement, ReactNode, useState } from 'react';
import styles from './block-dashboard-wrapper.module.scss';
import { ButtonRemake } from '@utmb/design-system/button-remake/ButtonRemake';
import { IconsEnum } from '@utmb/types/icons';
import ResizeObserver from 'react-resize-observer';

interface BlockDashboardWrapperProps {
    buttonAction?: string | (() => void);
    buttonLabel?: string;
    children: ReactNode;
    className?: string;
    label?: ReactNode;
    linkLabel?: string;
    linkUrl?: string | (() => void);
    linkOrSubtitleOnRight?: boolean;
    onChange?: () => void;
    standalone?: boolean;
    subtitle?: ReactNode;
    variant?: 'dark' | 'light';
}

export const BlockDashboardWrapper = (props: BlockDashboardWrapperProps): ReactElement => {
    const { children, label, linkLabel, linkUrl, linkOrSubtitleOnRight, subtitle, className, onChange, standalone, variant, buttonLabel, buttonAction } = props;
    const [isMobile, setIsMobile] = useState(false);

    return (
        <div
            className={[styles.container, className, standalone ? styles.standalone : null, variant === 'light' ? styles.light : styles.dark]
                .filter(Boolean)
                .join(' ')}
        >
            <ResizeObserver
                onResize={() => {
                    const isWindowMobile = window.innerWidth < parseInt(styles['bp-lg'], 10);
                    setIsMobile(isWindowMobile);
                }}
            />
            {label && (
                <div className={styles.head}>
                    <div className={styles.label}>{label}</div>
                    {linkOrSubtitleOnRight && !isMobile && (subtitle || linkLabel) ? (
                        <div className={styles.wrapSubtitleLink}>
                            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
                            {linkLabel && linkUrl ? <ButtonRemake action={linkUrl} label={linkLabel} variant="link" /> : null}
                        </div>
                    ) : null}
                    {onChange && (
                        <Link.Default
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                onChange();
                            }}
                            variant={IconsEnum.PEN}
                            className={styles.link}
                            label={''}
                        />
                    )}
                </div>
            )}
            <div className={styles.content}>
                {(!linkOrSubtitleOnRight || isMobile) && (subtitle || linkLabel) ? (
                    <div className={styles.wrapSubtitleLink}>
                        {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
                        {linkLabel && linkUrl ? <ButtonRemake action={linkUrl} label={linkLabel} variant="link" /> : null}
                    </div>
                ) : null}
                {children}
                {buttonLabel && buttonAction ? (
                    <ButtonRemake variant="solid" label={buttonLabel} action={buttonAction} customClassName={styles.button} />
                ) : null}
            </div>
        </div>
    );
};
